/**
 * The static loading splash in index.html covers the page while the JS bundle
 * and BootScene's asset preload run. The first real scene to reach create()
 * (MenuScene, or DemoScene under ?debug) calls this to fade it out.
 */
export function hideBootSplash(): void {
  const splash = document.getElementById('boot-splash');
  if (!splash) return;
  splash.classList.add('boot-splash--hidden');
  window.setTimeout(() => splash.remove(), 450);
}
